export enum Languages {
	EN = "en",
	UK = "uk",
}

export enum LanguageNames {
	EN = "English",
	UK = "Українська",
}
